// Base de l'API consommée par toutes les actions Vuex (apiUrl + "api/...").
//
// Depuis le 08/10/2026, front et API sont sur app.evolisstructures.fr
// (auparavant rituel.tunityengineering.com, et avant encore
// tunityengineering.com/admin/). Le sous-domaine pointe sur l'ancien
// dossier admin/ : le front est à sa racine, l'app Laravel dans service/, et sa
// racine WEB est service/public/ — le seul chemin où index.php s'exécute.
//
// Ne pas retirer le /public/ par une réécriture .htaccess. Symfony déduit
// l'URL de base en comparant SCRIPT_NAME et REQUEST_URI ; si le segment
// disparaît de la seconde, la déduction échoue et toutes les routes
// répondent 404 avec un message vide — panne déjà rencontrée en production.
//
// Pour une URL sans /public/, la seule méthode fiable est un sous-domaine
// dédié à l'API dont la racine web pointe sur service/public/.
export const apiUrl = 'https://app.evolisstructures.fr/service/public/';

// Même origine : sert aux fichiers générés (devis, factures, pochettes).
export const apiUrlFile = 'https://app.evolisstructures.fr/service/public/';

// --- Développement local -----------------------------------------------
// Décommenter la paire voulue et commenter celle du dessus.
//
// export const apiUrl     = 'http://127.0.0.1:8000/';
// export const apiUrlFile = 'http://127.0.0.1:8000/';
